// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyState_container__mMp3A {
  padding: 80px 24px;
  background-color: #fafafa;
  border: 1px solid var(--light-grey, #e8e8e8);
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.EmptyState_content__G30tn {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 520px;
  animation: EmptyState_fade-in__spP6T 0.4s ease-out;
}

@keyframes EmptyState_fade-in__spP6T {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.EmptyState_iconWrapper__g2RGi {
  font-size: 24px;
  color: var(--text-2, #6b7280);
  margin-bottom: 20px;
  opacity: 0.6;
}

.EmptyState_textWrapper__W4J9q {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.EmptyState_title__s1nwv {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
  letter-spacing: -0.01em;
}

.EmptyState_description__gZhNx {
  margin: 0;
  color: var(--text-2, #6b7280);
  font-size: 14px;
  line-height: 1.6;
}

.EmptyState_children__njvG\\+ {
  margin-top: 32px;
  width: 100%;
}

/* Suggestion chips */
.EmptyState_chipWrapper__vGRI3 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 600px;
  margin: 0 auto;
}

.EmptyState_suggestChip__OWy87 {
  background: transparent;
  border: 1px dashed var(--light-grey, #d1d5db);
  color: var(--explore-color, #0f3460);
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1.5;
}
.EmptyState_suggestChip__OWy87:hover {
  border-style: solid;
  border-color: var(--explore-color, #0f3460);
  background: #f8fafc;
}
.EmptyState_suggestChip__OWy87:active {
  background: #f1f5f9;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Collaborations/Components/EmptyState/EmptyState.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yBAAA;EACA,4CAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AACF;;AAEA;EACE;IAAO,UAAA;IAAY,0BAAA;EAGnB;EAFA;IAAK,UAAA;IAAY,wBAAA;EAMjB;AACF;AAJA;EACE,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AAMF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAMF;;AAHA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,uBAAA;AAMF;;AAHA;EACE,SAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,WAAA;AAMF;;AAHA,qBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAMF;;AAHA;EACE,uBAAA;EACA,6CAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAMF;AAJE;EACE,mBAAA;EACA,2CAAA;EACA,mBAAA;AAMJ;AAHE;EACE,mBAAA;AAKJ","sourcesContent":[".container {\n  padding: 80px 24px;\n  background-color: #fafafa;\n  border: 1px solid var(--light-grey, #e8e8e8);\n  border-radius: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 520px;\n  animation: fade-in 0.4s ease-out;\n}\n\n@keyframes fade-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.iconWrapper {\n  font-size: 24px;\n  color: var(--text-2, #6b7280);\n  margin-bottom: 20px;\n  opacity: 0.6;\n}\n\n.textWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--text-1, #1a1a2e);\n  letter-spacing: -0.01em;\n}\n\n.description {\n  margin: 0;\n  color: var(--text-2, #6b7280);\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.children {\n  margin-top: 32px;\n  width: 100%;\n}\n\n/* Suggestion chips */\n.chipWrapper {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.suggestChip {\n  background: transparent;\n  border: 1px dashed var(--light-grey, #d1d5db);\n  color: var(--explore-color, #0f3460);\n  border-radius: 4px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  line-height: 1.5;\n\n  &:hover {\n    border-style: solid;\n    border-color: var(--explore-color, #0f3460);\n    background: #f8fafc;\n  }\n\n  &:active {\n    background: #f1f5f9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EmptyState_container__mMp3A`,
	"content": `EmptyState_content__G30tn`,
	"fade-in": `EmptyState_fade-in__spP6T`,
	"iconWrapper": `EmptyState_iconWrapper__g2RGi`,
	"textWrapper": `EmptyState_textWrapper__W4J9q`,
	"title": `EmptyState_title__s1nwv`,
	"description": `EmptyState_description__gZhNx`,
	"children": `EmptyState_children__njvG+`,
	"chipWrapper": `EmptyState_chipWrapper__vGRI3`,
	"suggestChip": `EmptyState_suggestChip__OWy87`
};
export default ___CSS_LOADER_EXPORT___;
